import { LoaderCircle } from 'lucide-react';

export function PublicationEntry({
  pendingCount = 0,
  pendingLoading = false,
  publishing = false,
  onOpen,
  className = '',
}: {
  pendingCount?: number;
  pendingLoading?: boolean;
  publishing?: boolean;
  onOpen?(): void;
  className?: string;
}) {
  const label = pendingLoading
    ? 'Checking changes…'
    : publishing
      ? 'Publishing…'
      : pendingCount === 0
        ? 'Up to date · Republish website'
        : `${pendingCount} change${pendingCount === 1 ? '' : 's'} not live yet`;
  return (
    <button
      className={`publication-entry ${className}`}
      type="button"
      data-state={pendingCount > 0 ? 'pending' : 'current'}
      aria-label={label}
      aria-busy={publishing || undefined}
      disabled={pendingLoading}
      onClick={onOpen}
    >
      {publishing ? (
        <LoaderCircle className="publish-spinner" size={20} aria-hidden="true" />
      ) : null}
      <span className="publication-entry__copy">
        <strong>
          {pendingLoading || publishing
            ? label
            : pendingCount === 0
              ? 'The site is up to date'
              : `${pendingCount} change${pendingCount === 1 ? '' : 's'} not live yet`}
        </strong>
        <small>
          {publishing
            ? 'View progress'
            : pendingCount === 0
              ? 'Republish website'
              : 'Review and publish'}
        </small>
      </span>
      <span className="publication-entry__action" aria-hidden="true">
        {pendingLoading
          ? 'Checking…'
          : publishing
            ? 'Progress'
            : pendingCount === 0
              ? 'Republish'
              : 'Publish'}
      </span>
    </button>
  );
}
